import { withNamespaces } from "react-i18next";
import { Card, CardHeader, Col, Label, ListGroup, ListGroupItem, Row } from "reactstrap";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';

const AcceptanceInformation = ({ t, risk }) => {
    const dateUtils = new DateUtils();
    
    return (
        <Card
            outline
            body
            className='border border-primary rounded'
            style={{
                width: 'auto'
            }}
        >
            <CardHeader>
                <span className="me-2">
                    {t('Risk Acceptance')}
                </span>

                <span
                    className='badge bg-success text-white rounded'
                >{t('Accepted')}</span>
            </CardHeader>

            <ListGroup flush style={{ borderRadius: '0' }}>
                <ListGroupItem className='border-bottom border-primary '>
                    <Row>
                        <Col>
                            <p className="mb-0">
                                {t('Accepted by')}
                            </p>
                        </Col>
                        <Col>
                            <span 
                                className='d-block' 
                            >
                                {risk.acceptance.accepted_by?.name}
                            </span>
                        </Col>
                    </Row>
                </ListGroupItem>

                <ListGroupItem className='border-bottom border-primary'>
                    <Row>
                        <Col>
                            <p className="mb-0">
                                {t('Accepted on')}
                            </p>
                        </Col>
                        <Col>
                            <Label>
                                {dateUtils.convertTimeStampToDate(risk.acceptance.accepted_at, INTERNATIONAL_DATE_FORMAT)}
                            </Label>
                        </Col>
                    </Row>
                </ListGroupItem>

                <ListGroupItem>
                    <Row>
                        <Col>
                            <p className="mb-0">
                                {t('Justification')}
                            </p>
                        </Col>
                        <Col>
                            {risk.acceptance.reason}
                        </Col>
                    </Row>
                </ListGroupItem>
            </ListGroup>
        </Card>
    );
};

export default withNamespaces()(
    AcceptanceInformation
);
